import type { ThemeConfig } from 'antd';
import { theme } from 'antd';

import type { ResolvedColorScheme } from '@/config/colorScheme';

const sharedToken: ThemeConfig['token'] = {
  colorPrimary: '#1677ff',
  borderRadius: 8,
  fontSize: 14,
  fontFamily: 'var(--font-sans)',
};

const darkToken: NonNullable<ThemeConfig['token']> = {
  ...sharedToken,
  colorBgContainer: '#141e30',
  colorBgElevated: '#1a2332',
  colorBgLayout: '#0d1424',
  colorText: '#e2e8f0',
  colorTextSecondary: '#94a3b8',
  colorBorder: 'rgba(255, 255, 255, 0.06)',
  colorBorderSecondary: 'rgba(255, 255, 255, 0.04)',
};

const lightToken: NonNullable<ThemeConfig['token']> = {
  ...sharedToken,
  colorBgContainer: '#ffffff',
  colorBgElevated: '#ffffff',
  colorBgLayout: '#f5f5f5',
  colorText: 'rgba(0, 0, 0, 0.88)',
  colorTextSecondary: 'rgba(0, 0, 0, 0.65)',
  colorBorder: '#d9d9d9',
  colorBorderSecondary: '#f0f0f0',
};

const darkComponents: ThemeConfig['components'] = {
  Layout: {
    headerBg: 'rgba(13, 20, 36, 0.98)',
    siderBg: '#0d1424',
    bodyBg: 'transparent',
  },
  Menu: {
    darkItemBg: 'transparent',
    darkSubMenuItemBg: 'transparent',
  },
  Button: {
    borderRadius: 6,
  },
  Card: {
    colorBgContainer: '#141e30',
  },
};

const lightComponents: ThemeConfig['components'] = {
  Layout: {
    headerBg: '#ffffff',
    siderBg: '#fafafa',
    bodyBg: 'transparent',
  },
  Menu: {
    itemBg: 'transparent',
    subMenuItemBg: 'transparent',
  },
  Button: {
    borderRadius: 6,
  },
  Card: {
    colorBgContainer: '#ffffff',
  },
};

/**
 * Cấu hình Ant Design theo scheme đã resolve (sáng/tối từ hệ thống).
 */
export function getAntdThemeConfig(resolved: ResolvedColorScheme): ThemeConfig {
  const isDark = resolved === 'dark';
  return {
    token: isDark ? darkToken : lightToken,
    components: isDark ? darkComponents : lightComponents,
    algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
    cssVar: { prefix: 'ant' },
  };
}
